export default __webpack_public_path__ + "static/media/Trade.07d1b9b2.jpg";